export default "__VITE_ASSET__a1a238fd__"